import React, { useEffect, useState } from 'react';
import useRUMView from 'common-datadog/useRUMView';
import OfferPoll from '../OfferPoll';
import Screen from '../Screen';

const Approved = () => {
  useRUMView('approved');
  const [error, setError] = useState();

  useEffect(() => {
    // 60sec timeout for offer polling
    const id = setTimeout(() => setError(true), 60_000);
    return () => clearInterval(id);
  });

  if (error) {
    return (
      <Screen
        header="Sorry, things are taking a bit longer than expected."
        subheader="Try refreshing to see if your offer is ready."
      />
    );
  }

  return <OfferPoll />;
};

export default Approved;
